import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';

const SearchResults = () => {
  const { query } = useParams();
  const [searchResults, setSearchResults] = useState([]);
  const [logoInfo, setLogoInfo] = useState({}); // Store logo info by ticker
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSearchResults = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await axios.get(
          `https://stocksleuth.xyz:5000/call?url=${encodeURIComponent(`https://query1.finance.yahoo.com/v1/finance/search?q=${query}`)}`
        );
        const quotes = response.data.quotes;

        // Filter out results with exchanges other than NYSE and NASDAQ
        const filteredResults = quotes.filter(
          (result) => result.exchange === 'NYQ' || result.exchange === 'NMS' || result.exchange === 'NCM'
        );

        setSearchResults(filteredResults);

        // Fetch logo info for each ticker
        const logos = await Promise.all(
          filteredResults.map(async (result) => {
            try {
              const logoResponse = await axios.get(
                `https://stocksleuth.xyz:5000/auth/getwebsite?ticker=${result.symbol}`
              );
              return { [result.symbol]: logoResponse.data.lastElement.text };
            } catch (error) {
              console.error(`Error fetching logo for ${result.symbol}`, error);
              return { [result.symbol]: null }; // Handle missing logos
            }
          })
        );

        // Combine logos into a single object
        setLogoInfo(Object.assign({}, ...logos));
      } catch (error) {
        console.error('Error fetching search results', error);
        setError('Search results could not be loaded. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchSearchResults();
  }, [query]);

  return (
    <div className="searchResultsPage" style={{ position: 'absolute', left: 0, right: "var(--sidebar-width, 306px)", height: '100%' }}>
      <p style={{ marginTop: 45, marginLeft: 40, textAlign: 'left' }}>
        Search Results for "{query}"
      </p>
      {loading && <div className="searchResultsState" role="status">Searching…</div>}
      {!loading && error && <div className="searchResultsState searchResultsError" role="alert">{error}</div>}
      {!loading && !error && !searchResults.length && <div className="searchResultsState">No matching companies found.</div>}
      {!loading && !error && <ul style={{ listStyle: 'none', padding: 0, marginTop: 40 }}>
        {searchResults.map((result) => (
          <li
            key={result.symbol}
            style={{ marginBottom: '20px' }} // Add spacing between list items
          >
            {result.exchange === 'NYQ' || result.exchange === 'NMS' || result.exchange === 'NCM' ? (
              <div className="searchResultCard"
              style={{
                background: 'white',
                boxShadow: '0px 10px 60px rgba(225.83, 236.19, 248.63, 0.50)',
                borderRadius: '20px',
                padding: '30px 50px 30px 30px', // Add padding inside the box
                margin: '0 95px 0 40px', // Add horizontal margin for alignment
                display: 'flex', // Align content horizontally
                alignItems: 'center', // Vertically center content
                gap: '20px', // Add space between logo and text
              }}
            >
              {/* Display logo if available */}
              {logoInfo[result.symbol] && (
                <img
                  src={`https://logo.clearbit.com/${logoInfo[result.symbol]}`}
                  alt={result.symbol}
                  style={{
                    maxWidth: '50px', // Set maximum width
                    maxHeight: '50px', // Set maximum height
                    objectFit: 'contain',
                    borderRadius: 15, // Ensure the image scales without distorting
                  }}
                />
              )}
            
              {/* Shortname and ticker as a link */}
              <Link
                to={`/stock/${result.symbol}`}
                style={{
                  textDecoration: 'none',
                  color: 'black',
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <span style={{ textAlign: 'left' }}>{result.shortname}</span>
                <span style={{ textAlign: 'right' }}>{result.symbol}</span>
              </Link>
            </div>
            
            ) : (
              <span>
                {result.shortname} ({result.symbol}) - {result.exchDisp}
              </span>
            )}
          </li>
        ))}
      </ul>}
      <a href="https://clearbit.com" style={{ textDecoration: 'none', color: 'inherit', fontSize: '12px', position: 'absolute', bottom:6, right: '95px'}}>Logos provided by Clearbit</a>

    </div>
  );
};

export default SearchResults;
